import { adobeEmbedApiClientId } from '../shared/constant'

class ViewSDKClient {
  constructor() {
    this.readyPromise = new Promise((resolve) => {
      if (window.AdobeDC) {
        resolve()
      } else {
        document.addEventListener('adobe_dc_view_sdk.ready', () => {
          resolve()
        })
      }
    })
    this.adobeDCView = undefined
  }

  ready() {
    return this.readyPromise
  }

  previewFile(divId, viewerConfig, url, fileName, fileId) {
    const config = {
      clientId: adobeEmbedApiClientId,
    }

    if (divId) {
      config.divId = divId
    }

    this.adobeDCView = new window.AdobeDC.View(config)
    const previewFilePromise = this.adobeDCView.previewFile(
      {
        content: {
          location: {
            url: url,
          },
        },
        metaData: {
          fileName: fileName,
          id: fileId,
        },
      },
      viewerConfig
    )

    return previewFilePromise
  }
}

export default ViewSDKClient
